import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "../pages/admin/Home";
import HomeUser from "../pages/user/HomeUser";
import Braiding from "../pages/admin/Braiding";
import Styles from "../pages/user/Styles";
import Login from "../pages/auth/Login";
import Booking from "../pages/admin/Booking";
import BookingUser from "../pages/user/BookingUser";
import AuthService from "../services/AuthServices";
import ResetPassword from "../pages/auth/ResetPassword";
import Order from "../pages/admin/Order";
import injectColors from "../assets/config/InjectorColor";
import RegisterUser from "../pages/auth/RegisterUser";

function AuthRoute({ children }) {
  return AuthService.isLoggedIn() ? children : <Navigate to="/" replace />;
}

function index() {
  injectColors();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/register" element={<RegisterUser />} />
        <Route path="/home/*" element={<AuthRoute><Home /></AuthRoute>} />
        <Route path="/homeUser/*" element={<AuthRoute><HomeUser /></AuthRoute>} />
        <Route path="/menu/*" element={<AuthRoute><Braiding /></AuthRoute>} />
        <Route path="/styles/*" element={<AuthRoute><Styles /></AuthRoute>} />
        <Route path="/table/*" element={<AuthRoute><Booking /></AuthRoute>} />
        <Route path="/order/*" element={<AuthRoute><Order /></AuthRoute>} />
        <Route path="/bookingUser/*" element={<AuthRoute><BookingUser /></AuthRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default index;
